"use strict";
/*
 * @license
 * Copyright (c) 2019 Cristian Abrante. All rights reserved.
 * Licensed under the MIT License. See LICENSE in the project root for license information.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../generator/utils");

var base_1 = require("../../individual/numeric/base");

var BaseCrossover_1 = require("./BaseCrossover");

var NPointsCrossover =
/** @class */
function (_super) {
  __extends(NPointsCrossover, _super);

  function NPointsCrossover() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.crossoverPointsRange = base_1.NumericRange.DEFAULT;
    _this.crossoverPoints = [];
    _this.crossoverPointIndex = 0;
    return _this;
  }

  NPointsCrossover.prototype.cross = function (firstParent, secondParent, numberOfCrossoverPoints, individualConstructor, engine) {
    if (engine === void 0) {
      engine = utils_1.Generator.DEFAULT_ENGINE;
    }

    return this.crossWith(firstParent, secondParent, {
      engine: engine,
      individualConstructor: individualConstructor,
      numberOfCrossoverPoints: numberOfCrossoverPoints
    });
  };

  NPointsCrossover.prototype.crossWith = function (firstParent, secondParent, params) {
    var parentsLength = firstParent.length();
    this.setCrossoverPointsRange(parentsLength);
    this.checkCrossoverParams(params);
    this.generateCrossoverPoints(params);
    this.crossoverPointIndex = 0;
    return _super.prototype.crossWith.call(this, firstParent, secondParent, params);
  };

  NPointsCrossover.prototype.getGenotypeValues = function (firstParent, secondParent, params, index) {
    var crossPoint = this.crossoverPoints[this.crossoverPointIndex];

    if (index >= crossPoint && this.crossoverPointIndex < this.crossoverPoints.length) {
      this.crossoverPointIndex += 1;
    }

    var parentSelectionCondition = this.crossoverPointIndex % 2 === 0;
    return {
      first: parentSelectionCondition ? firstParent.get(index) : secondParent.get(index),
      second: parentSelectionCondition ? secondParent.get(index) : firstParent.get(index)
    };
  };

  NPointsCrossover.prototype.setCrossoverPointsRange = function (parentsLength) {
    this.crossoverPointsRange = new base_1.NumericRange(0, parentsLength - 1);
  };

  NPointsCrossover.prototype.checkCrossoverParams = function (params) {
    if (!base_1.NumericRange.isValueInRange(params.numberOfCrossoverPoints, this.crossoverPointsRange)) {
      throw new Error("NPointsCrossover: number of crossover points must be in range [" + this.crossoverPointsRange.lowest + ", " + this.crossoverPointsRange.highest + "]");
    }
  };

  NPointsCrossover.prototype.generateCrossoverPoints = function (params) {
    this.crossoverPoints = [];

    while (this.crossoverPoints.length !== params.numberOfCrossoverPoints) {
      var point = utils_1.Generator.generateInteger(this.crossoverPointsRange, params.engine);

      if (!this.crossoverPoints.includes(point)) {
        this.crossoverPoints.push(point);
      }
    }

    this.crossoverPoints.sort();
  };

  return NPointsCrossover;
}(BaseCrossover_1.default);

exports.default = NPointsCrossover;